var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"toast",class:{ 'toast-success': _vm.type === 'success', 'toast-error': _vm.type === 'error' },on:{"click":_vm.hideToast}},[_c('div',{staticClass:"toast-content"},[_c('i',{class:_vm.iconClass}),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }